import { BlockStack, Box, Card, Icon, InlineStack, Link, Text } from "@shopify/polaris";
import { ChevronDownIcon, ChevronRightIcon, QuestionCircleIcon } from "@shopify/polaris-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface FAQProps {
  children?: React.ReactNode;
}

export const FAQ = ({ children }: FAQProps) => {
  const navigate = useNavigate();

  return (
    <Card>
      <BlockStack gap="300">
        <InlineStack align="start" gap="100">
          <div>
            <Icon source={QuestionCircleIcon} />
          </div>
          <Box paddingInlineStart="200">
            <Text as="h5" variant="headingMd">
              FAQ
            </Text>
          </Box>
        </InlineStack>
        <BlockStack gap="200">
          {children}
          <Section
            answer={
              <p>
                <b>Step 1:</b> (Button in our settings will take you right there) To enable pop-up blocking
                (non-checkout): Go to store {">"} theme {">"} customize {">"} app embeds and toggle KeepCart on. <br />{" "}
                <br />
                <b>Step 2:</b> (Button in our settings will take you right there) To enable checkout extension blocking:
                Go to settings {">"} checkout {">"} customize and click on the keepcart app embed to add it to the
                checkout page
              </p>
            }
            question="How do I setup Extension Blocking for Checkout Extensibility?"
          />
          <Section
            answer={
              <div>
                Due to Shopify’s restrictions we are not able to block the extension pop-ups in the checkout page -
                although, great news, we can still stop all extension injections (codes will all be marked invalid for
                customers). You can even provide a code to customers who try to apply codes that’s much lower than what
                they would normally receive from extensions. You can add it in the{" "}
                <Link
                  onClick={() => {
                    navigate("/settings");
                  }}
                >
                  settings
                </Link>
                . So long extension headaches!
              </div>
            }
            question="How does  Extension Blocking for Checkout Extensibility work?"
          />
          <Section
            answer="Nice! We love receiving feature requests - Send requests to support@keepcart.co"
            question="Where can I submit a feature request?"
          />
          <Section
            answer="We’re happy to help with anything! - Reach out to us at support@keepcart.co"
            question="I have more questions. Who can I reach out to?"
          />
        </BlockStack>
      </BlockStack>
    </Card>
  );
};

interface SectionProps {
  answer: React.ReactNode;
  question: string;
}

const Section = ({ answer, question }: SectionProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      onClick={() => {
        setOpen(!open);
      }}
    >
      <Box>
        <BlockStack>
          <InlineStack>
            <InlineStack gap="200">
              <Icon source={open ? ChevronDownIcon : ChevronRightIcon} tone="primary" />
              <Box paddingInlineStart="100">
                <Text as="h6" fontWeight="medium" variant="headingMd">
                  {question}
                </Text>
              </Box>
            </InlineStack>
          </InlineStack>
          {open && (
            <Box paddingBlock="200" paddingInlineStart="800">
              {answer}
            </Box>
          )}
        </BlockStack>
      </Box>
    </div>
  );
};

FAQ.Section = Section;
export default FAQ;
